import { Button, styled } from "@mui/material";
import { SettingsIcon } from "@volt_developers/components";
import { useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";

import { TEST_IDS } from "../../constants/TestIds";

export interface FiltersButtonProps {
  onClick: VoidFunction;
  filtersNumber?: number | null;
}

export function FiltersButton({ filtersNumber, onClick }: FiltersButtonProps) {
  const { t } = useTranslation("common");
  const isFiltersNumber = Boolean(filtersNumber);

  return (
    <FilterButton
      data-testid={TEST_IDS.filtersButton}
      variant="outlined"
      startIcon={
        <IconWrapper>
          <SettingsIcon sx={{ fontSize: 18 }} />
        </IconWrapper>
      }
      onClick={onClick}
    >
      <Text
        sx={(theme) => ({
          padding: !isFiltersNumber ? theme.spacing(0, 1) : theme.spacing(0),
          margin: !isFiltersNumber ? theme.spacing(0, 0.5) : 0,
        })}
      >
        {t(COMMON_TRANSLATION_KEYS.filters)}
      </Text>
      {isFiltersNumber && (
        <Circle data-testid={TEST_IDS.filtersNumber}>{filtersNumber}</Circle>
      )}
    </FilterButton>
  );
}

const FILTER_BUTTON_HEIGHT = 36;
const FILTER_COUNT_SIZE = 16;

const IconWrapper = styled("span")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const FilterButton = styled(Button)(({ theme }) => ({
  height: FILTER_BUTTON_HEIGHT,
  border: `1px solid ${theme.palette.ui50}`,
  backgroundColor: theme.palette.ui12,
  color: theme.palette.text.medium,
  letterSpacing: "unset",

  "& svg": {
    color: theme.palette.text.low,
  },
}));

const Text = styled("span")``;

const Circle = styled("span")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: theme.spacing(1),
  width: FILTER_COUNT_SIZE,
  height: FILTER_COUNT_SIZE,
  borderRadius: "50%",
  backgroundColor: theme.palette.primary[800],
  fontSize: 10,
  lineHeight: "12px",
  fontWeight: 500,
  color: theme.palette.text.white,
}));
